module.exports = __webpack_public_path__ + "media/images/banner_bg-6d775fcb6d52b6c9d0b9df8a037d4023.svg";